var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-market-item"},[_c('span',{staticClass:"bto-sb-market-name"},[_vm._v(" "+_vm._s(_vm.outcome.enrichedOutcomeName || _vm.outcome.name))]),(_vm.outcome.id > 0)?_c('span',{class:[
      'bto-sb-event-odd',
      {
        'bto-sb-odd-lock':
          _vm.outcome.outcome === '--' || _vm.outcome.active === false || _vm.match.isBetStop || _vm.isSuspended,
        'bto-sb-event-odd-active': _vm.isOddSelected,
        [_vm.updateClasses[`class-${_vm.outcome.upDownClass}`]]: true,
        'bto-sb-event-odd-x': _vm.outcome.name === _vm.xOutcomeName,
      },
      _vm.quickBetClasses,
    ],on:{"click":function($event){$event.preventDefault();return _vm.processOdds()}}},[(_vm.getQuickBetNotification && _vm.getQuickBetNotification.betslip.status === 4)?_c('span',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),_c('i',[_vm._v(_vm._s(_vm.formatOddDisplay(_vm.outcome.originalDecimalOutcome, _vm.$root.oddFormat)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }